import React from "react"

import { Container } from "./style"

const Footer = () => {
  return <Container>udaraw.com © {new Date().getFullYear()}</Container>
}

export default Footer
